import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
export const formatDateToLocal = (utcDateString: string) => {
  const date = new Date(utcDateString);
  return date.toLocaleString(undefined, {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: false,
  });
};

export const formatBytes = (bytes: number, decimals = 2) => {
  if (!bytes) return '0 Bytes';
  const k = 1024;
  const dm = decimals < 0 ? 0 : decimals;
  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`;
};

export const timeToSeconds = (time: string) => {
  if (!time) return 0;
  const [hh, mm, ss] = time.split(':').map(Number);
  return hh * 3600 + mm * 60 + ss;
};

export const calculateTotalTime = (timeEntries: any[]) => {
  let totalSeconds = 0;
  timeEntries.forEach((entry) => {
    const [hours, minutes, seconds] = entry?.timeTracker?.split(':').map(Number);
    totalSeconds += hours * 3600 + minutes * 60 + seconds;
  });
  const totalHours = Math.floor(totalSeconds / 3600);
  const totalMinutes = Math.floor((totalSeconds % 3600) / 60);
  const totalSecs = totalSeconds % 60;
  return `${String(totalHours).padStart(2, '0')}:${String(totalMinutes).padStart(2, '0')}:${String(totalSecs).padStart(2, '0')}`;
};

export const roundUpToBillingIncrementSeconds = (seconds: number, minMinutes: number) => {
  if (!Number.isFinite(seconds) || seconds <= 0) return 0;
  if (!Number.isFinite(minMinutes) || minMinutes <= 0) return Math.max(0, seconds);
  const increment = minMinutes * 60;
  return Math.ceil(seconds / increment) * increment;
};

export const calculatePrice = (
  hourlyRate: number,
  timeSpent: string,
  minBillingMinutes: number,
): number => {
  const totalSeconds = timeToSeconds(timeSpent);
  if (totalSeconds <= 0) return 0;
  const billedSeconds = roundUpToBillingIncrementSeconds(totalSeconds, minBillingMinutes);
  const totalHours = billedSeconds / 3600;
  return parseFloat((hourlyRate * totalHours).toFixed(2));
};

export const calculateTotalAmount = (
  hourlyRate: number,
  timeTrackers: any[],
  minBillingMinutes: number,
): number => {
  return timeTrackers.reduce((total, tracker) => {
    const timeInSeconds = timeToSeconds(tracker?.timeTracker);
    if (timeInSeconds > 0 && !tracker?.expenditure) {
      total += calculatePrice(hourlyRate, tracker?.timeTracker, minBillingMinutes);
    }
    if (tracker?.expenditure) {
      total += parseFloat(tracker.expenditure);
    }
    return total;
  }, 0);
};

export const filterNonNull = (obj: Record<string, any>) => {
  return Object.fromEntries(Object.entries(obj).filter(([_, v]) => v !== undefined && v !== null && v !== ''));
};

export const getQueryString = (pathname: string | null, values: any) => {
  const filter: any = filterNonNull(values);
  const query = new URLSearchParams(filter).toString().replace(/%2C/g, ',');
  return `${pathname}?${query}`;
};

export const compararPorNumeroEnDescripcion = (a: any, b: any) => {
  const numA = parseInt(a?.description?.match(/^\d+/)?.[0] || '0', 10);
  const numB = parseInt(b?.description?.match(/^\d+/)?.[0] || '0', 10);
  return numA - numB;
};
